<template>
  <div>
    <b-row align-h="between" class="mx-3">
      <div class="my-1 col-md-3">
        Showing {{ from }} to {{ to }} of {{ totalItems }} assignments
      </div>

      <div class="col-md-3 my-1">
        <b-pagination
          :total-rows="totalItems"
          :per-page="perPage"
          :value="currentPage"
          @input="setPage"
          class="my-0 pagination-holder"
          prev-text="Prev"
          next-text="Next"
          align="fill"
        />
      </div>

      <div class="col-md-3 my-1">
        <b-form-group
          label="Per Page"
          label-align="right"
          label-cols="7"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            :value="perPage"
            @change="setPerPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
            align="right"
          ></b-form-select>
        </b-form-group>
      </div>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      ref="assignmentTable"
      class="border-bottom"
      :filter="`location.name=${searchText}`"
      :busy="isLoading"
      :items="assignmentsProvider"
      :fields="tableFields"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
    >
      <template #cell(type)="row">
        <template v-if="row.item.member"
          ><i class="fas fa-user mr-2"></i>User</template
        >
        <template v-else-if="row.item.datasheet"
          ><i class="fas fa-file mr-2"></i>Datasheet</template
        >
        <template v-else><i class="fas fa-people mr-2"></i>Project</template>
      </template>
      <template #cell(member.member.firstName)="row">
        <template v-if="row.item.member">
          {{ row.item.member.member.firstName }}
          {{ row.item.member.member.lastName }}
        </template>
        <template v-else>
          <i>All Members</i>
        </template>
      </template>
      <template #cell(datasheet.name)="row">
        <template v-if="row.item.datasheet">
          {{ row.item.datasheet.name }}
        </template>
        <template v-else>
          <i>All Datasheets</i>
        </template>
      </template>
      <template v-slot:cell(createdAt)="row">
        <DateTime :date="row.item.createdAt" :dateTime="false"></DateTime>
      </template>
      <template v-slot:cell(updatedAt)="row">
        <DateTime :date="row.item.updatedAt" :dateTime="false"></DateTime>
      </template>
      <template v-slot:cell(options)="row">
        <div class="options-holder float-right">
          <b-btn
            size="sm"
            class="my-1 mr-1"
            @click="onDeleteAssignment(row.item)"
            alt="Remove this Assigned Location"
            title="Remove this Assigned Location"
          >
            <font-awesome-icon icon="times" />
            Delete
          </b-btn>
        </div>
      </template>
      <template #table-busy>
        <VueLoader style="height: 200px" text="Loading Assignments..." />
      </template>
    </b-table>
    <b-row align-h="between" class="mx-3">
      <div class="my-1 col-md-3">
        Showing {{ from }} to {{ to }} of {{ totalItems }} assignments
      </div>

      <div class="col-md-3 my-1">
        <b-pagination
          :total-rows="totalItems"
          :per-page="perPage"
          :value="currentPage"
          @input="setPage"
          class="my-0 pagination-holder"
          prev-text="Prev"
          next-text="Next"
          align="fill"
        />
      </div>

      <div class="col-md-3 my-1">
        <b-form-group
          label="Per Page"
          label-align="right"
          label-cols="7"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            :value="perPage"
            @change="setPerPage"
            id="perPageSelect"
            size="sm"
            :options="pageOptions"
            align="right"
          ></b-form-select>
        </b-form-group>
      </div>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import VueLoader from "../layout/Loader";
import DateTime from "../common/date-time/DateTime.vue";

export default {
  name: "assignmentTable",
  components: {
    VueLoader,
    DateTime,
  },
  data() {
    return {
      pageOptions: [10, 25, 50, 100],
      showModal: null,
      selectedObservation: null,
      searchText: "",
      sortBy: "observedAt",
      sortDesc: true,
      sortDirection: "desc",
      tableFields: [
        {
          key: "type",
          label: "Assignment Type",
          sortable: false,
          tdClass: "text-dark",
        },
        {
          key: "member.member.firstName",
          label: "Who",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "datasheet.name",
          label: "Datasheet",
          sortable: true,
          sortDirection: "asc",
        },
        {
          key: "createdAt",
          label: "Created",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "updatedAt",
          label: "Updated",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "options",
          label: "",
          sortable: false,
          class: "text-right",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      membershipMap: "user/profile/membershipMap",
      assignments: "location/assignments",
      isLoading: "location/assignmentsIsLoading",
      totalItems: "location/assignmentsTotal",
      currentPage: "location/assignmentsPage",
      perPage: "location/assignmentsPerPage",
      from: "location/assignmentsFrom",
      to: "location/assignmentsTo",
      error: "location/assignmentsError",
    }),
  },
  methods: {
    ...mapActions({
      fetchAssignments: "location/fetchAssignments",
      deleteAssignment: "location/deleteAssignment",
    }),
    async assignmentsProvider(ctx, callback) {
      // let urlParams = `${this.urlBuilder(ctx)}`;
      await this.fetchAssignments(ctx);
      return this.assignments;
    },
    ...mapMutations({
      setPage: "location/LOCATION_SET_ASSIGNMENTS_PAGE",
      setPerPage: "location/LOCATION_SET_ASSIGNMENTS_PER_PAGE",
    }),

    onDeleteAssignment(assignment) {
      this.deleteAssignment(assignment).then((value) => {
        if (value) {
          this.$refs.assignmentTable.refresh();
        }
      });
    },
  },
};
</script>

<style></style>
